
import { Duration } from "luxon";

import {inflate} from 'pako';

const randomChoice = ary => {
    return ary[Math.floor(Math.random() * ary.length)];
}

function* zip(...args) {
	const iterators = args.map(x => x[Symbol.iterator]());
	while (true) {
		const current = iterators.map(x => x.next());
		if (current.some(x => x.done)) {
			break;
		}
		yield current.map(x => x.value);
	}
}

function pairwise(ary) {
	let ary1 = ary.slice();
    let ary2 = ary.slice();

    ary1.pop()
    ary2.shift();
  
    return zip(ary1, ary2);
}

function downloadGzipCompressed(rem_fname, pako_opts) {
    return fetch(rem_fname)
        .then(resp => resp.blob())
        .then(blob => blob.arrayBuffer())
        .then(bufr => new Uint8Array(bufr))
        .then(arry => inflate(arry, pako_opts))
}

function timeIsKnown(tor_props) {
    let time_accuracy;
    if (tor_props['time-accuracy'] !== undefined) {
        let acc_str = tor_props['time-accuracy'];
        if (acc_str.startsWith('GT')) {
            acc_str = acc_str.slice(2)
        }

        let lead_str = 'PT';
        if (acc_str.includes('D')) {
            lead_str = 'P';
        }

        time_accuracy = Duration.fromISO(lead_str + acc_str);
    }
    else if (tor_props['utc_check'] !== undefined && tor_props['utc_check'] == false) {
        time_accuracy = Duration.fromISO('P1D');
    }
    else {
        time_accuracy = Duration.fromISO('PT1H');
    }

    return time_accuracy <= Duration.fromISO('PT6H');
}

export {randomChoice, zip, pairwise, downloadGzipCompressed, timeIsKnown};